<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center">
            <b>{{ obj.xtitle }}</b>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <form class="form-horizontal">
            <div class="form-group" :class="{ 'has-error': validation.hasError('plataforma.nombre') }">
              <label for="inputEmail3" class="col-sm-2 control-label">Nombre: </label>
              <div class="col-sm-10">
                <input class="form-control input-sm" type="text" v-model="plataforma.nombre" placeholder="nombre" />
              </div>
              <div class="error" v-if="validation.hasError('plataforma.nombre')">
                {{ validation.firstError('plataforma.nombre') }}
              </div>
            </div>

            <div class="form-group" :class="{ 'has-error': validation.hasError('plataforma.direccion') }">
              <label for="inputEmail3" class="col-sm-2 control-label">Direccion: </label>
              <div class="col-sm-10">
                <input
                  class="form-control input-sm"
                  type="text"
                  v-model="plataforma.direccion"
                  placeholder="direccion url" />
              </div>
              <div class="error" v-if="validation.hasError('plataforma.direccion')">
                {{ validation.firstError('plataforma.direccion') }}
              </div>
            </div>

            <div class="form-group" :class="{ 'has-error': validation.hasError('plataforma.token') }">
              <label for="inputEmail3" class="col-sm-2 control-label">Token: </label>
              <div class="col-sm-10">
                <input class="form-control input-sm" type="text" v-model="plataforma.token" placeholder="token" />
              </div>
              <div class="error" v-if="validation.hasError('plataforma.token')">
                {{ validation.firstError('plataforma.token') }}
              </div>
            </div>
          </form>

          <p class="text-center text-danger" v-html="msg"></p>
        </div>

        <Alertas ref="alertar" />

        <div class="modal-footer">
          <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Enviar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue';
import { Validator } from 'simple-vue-validator';
import axios from 'axios';

export default {
  props: {
    obj: {
      // {xid:Number,xtitle:String,xbody:String,all:Boolean,isDefault:Boolean,xsql:Object,xcorreo:String,xasunto:String}
      type: Object,
      required: true,
    },
  },
  components: { Alertas },
  data() {
    return {
      activo: true,
      msg: '',
      plataforma: { nombre: '', direccion: '', token: '' },
    };
  },
  validators: {
    'plataforma.nombre'(value) {
      return Validator.value(value).required();
    },
    'plataforma.direccion'(value) {
      return Validator.value(value).required();
    },
    'plataforma.token'(value) {
      return Validator.value(value).required();
    },
  },
  watch: {
    'obj.xid': function () {
      if (this.obj.xid) {
        if (this.obj.xid) this.obj.xtitle = 'Editar Plataforma';
        this.plataforma.id = this.obj.xid;
        this.plataforma.nombre = this.obj.xnombre;
        this.plataforma.direccion = this.obj.xdireccion;
        this.plataforma.token = this.obj.xtoken;
      } else {
        this.plataforma.nombre = '';
        this.plataforma.direccion = '';
        this.plataforma.token = '';
        delete this.plataforma.id;
      }
    },
  },
  methods: {
    submit() {
      var vue = this;
      this.$validate().then((success) => {
        if (success) {
          if (vue.plataforma.id) vue.editar();
          else vue.crear();
        } else {
          vue.msg = 'complete correctamente los datos';
        }
      });
    },
    crear() {
      var obj = window.Object.assign({}, this.plataforma);
      delete obj.id;
      const unidad = this.$store.state.CARGO.sede.unidad_negocio;
      obj.unidadNegocioId = unidad;

      this.msg = '';

      axios
        .post(`${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas`, obj)
        .then((response) => {
          const data = response?.data;
          const mensaje = data?.mensaje;

          this.plataforma.nombre = '';
          this.plataforma.direccion = '';
          this.plataforma.token = '';
          this.$refs.alertar.success();
          this.$root.$notify.show(mensaje, { color: 'green' });
          this.$emit('exito');
          window.$('#modalpla').modal('hide');
        })
        .catch((error) => {
          this.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          const response = error?.response;
          const data = response?.data;
          const status = response?.status;
          const errores = data?.errores;
          const mensaje = data?.mensaje;
          let mensajesErrores = '';

          if (status == 422) {
            Object.values(errores).forEach((error) => {
              error.forEach((e) => {
                mensajesErrores += `${e}<br>`;
              });
            });

            this.msg = mensajesErrores;
          }

          this.$root.$notify.show(`${mensaje}`, { color: 'red' });
        });
    },
    editar() {
      const ob = window.Object.assign({}, this.plataforma);
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      ob.unidadNegocioId = unidad;

      this.msg = '';

      axios
        .patch(
          `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${this.plataforma.id}`,
          ob,
        )
        .then((response) => {
          const data = response?.data;
          const mensaje = data?.mensaje;

          this.plataforma.nombre = '';
          this.plataforma.direccion = '';
          this.plataforma.token = '';
          this.$refs.alertar.success();
          this.$root.$notify.show(mensaje, { color: 'green' });
          this.$emit('exito');
          window.$('#modalpla').modal('hide');
        })
        .catch((error) => {
          this.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          const response = error?.response;
          const data = response?.data;
          const status = response?.status;
          const errores = data?.errores;
          const mensaje = data?.mensaje;
          let mensajesErrores = '';

          if (status == 422) {
            Object.values(errores).forEach((error) => {
              error.forEach((e) => {
                mensajesErrores += `${e}<br>`;
              });
            });

            this.msg = mensajesErrores;
          }

          this.$root.$notify.show(`${mensaje}`, { color: 'red' });
        });
    },
  },
  mounted() {
    var vue = this;
    window.$('#modalpla').on('hidden.bs.modal', function () {
      vue.msg = '';
      vue.activo = true;
      vue.plataforma.nombre = '';
      vue.plataforma.direccion = '';
      vue.plataforma.token = '';
      vue.obj.xid = 0;
      vue.$refs.alertar.reset();
    });
  },
};
</script>